import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    // Check if user needs to complete payment (activation_status is not 'active')
    const { accounts = [] } = user || {};
    const currentAccount = accounts.find(account =>
      accountPath.includes(`accounts/${account.id}`)
    );

    // If activation_status is not active, redirect to checkout/suspended page
    if (currentAccount) {
      const { activation_status } = currentAccount;
      // inactive: new registration not paid, payment_required: admin after expiration
      if (
        activation_status === 'inactive' ||
        activation_status === 'payment_required'
      ) {
        return frontendURL(`${accountPath}/settings/checkout`);
      }
      // suspended: agent after expiration - redirect to suspended page
      if (activation_status === 'suspended') {
        return frontendURL(`${accountPath}/suspended`);
      }
    }

    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
